import ButtonT from '@components/tailwind-components/Button/ButtonT';
import { useModal } from '@hooks/modal/useModal';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { splitIntoLines } from '../../../helpers/domHelper';
import type { GeneralInfoModalProps } from './modals';

export const GeneralInfoModal: React.FC<GeneralInfoModalProps> = ({
  text,
  options,
}) => {
  const { shouldCloseButton = false } = options || {};
  const { t } = useTranslation();
  const { hideModal } = useModal();

  return (
    <div className='tailwind-modal-form'>
      <div className='tailwind-modal-body text-sm font-normal'>
        {splitIntoLines(text)}
      </div>
      {shouldCloseButton && (
        <div className='tailwind-modal-footer'>
          <ButtonT
            type='button'
            styling='primary'
            size='xs'
            rounding='md'
            onClick={hideModal}>
            {t('general.buttons.close')}
          </ButtonT>
        </div>
      )}
    </div>
  );
};

export default GeneralInfoModal;
